import {
  DANHSACHCOM_COUNT_ASSIGN_SUCCESS,
  DANHSACHCOM_HISTORY_LIST_SUCCESS,
  DANHSACHCOM_IMPORT_SUCCESS,
  DANHSACHCOM_LIST_SUCCESS,
  DANHSACHCOM_NEW_CARE_SUCCESS,
  DANHSACHCOM_ONE_SUCCESS,
  DANHSACHCOM_UPDATE_FILTER,
} from 'src/actions/danhsachcom.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const danhsachcomReducer = (state = initState, action) => {
  switch (action.type) {
    case DANHSACHCOM_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case DANHSACHCOM_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
        tongSoDuHienTai: action.data.tongSoDuHienTai,
        daNapHienTai: action.data.daNapHienTai,
        soTienConCoTheBanDuoc: action.data.soTienConCoTheBanDuoc,
      }
    }
    case DANHSACHCOM_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case DANHSACHCOM_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case DANHSACHCOM_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case DANHSACHCOM_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case DANHSACHCOM_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default danhsachcomReducer